import { Api_routes, server_url } from '../config/API_Routes';
import { postRequest, getRequest, putRequest, deleteRequest, patchRequest } from '../config/axios-config';

const createStage = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.stages,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getAllStages = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.stages
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};


const updateStageOrder = (id, order) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.stages + '/' + id,
        {
          order: order,
        }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateStageMetadata = (id, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.stages + '/' + id,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteStage = (id, toRelationshipStageId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.stages +
          '/' +
          id +
          (toRelationshipStageId ? '?toRelationshipStageId=' + toRelationshipStageId : '')
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getAllAutomationTriggers = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllStageTriggers
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateStageTrigger = ({ stageId, ...body }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateStageTrigger + '/' + stageId,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
export {
  createStage,
  getAllStages,
  updateStageMetadata,
  updateStageOrder,
  deleteStage,
  getAllAutomationTriggers,
  updateStageTrigger,
};
